import { ArrowsClockwise, Plus, Trash, Archive, Warning, MagicWand, FileXls, ArrowCounterClockwise } from "@phosphor-icons/react";

export default function OrdersHeaderActions({
  showOverdueOnly, onToggleOverdue, overdueCount,
  exporting, onExport, canAdmin,
  onRecover, onArchive, onManual,
  purging, onPurge, syncing, onSync,
  showDeleted, onToggleDeleted,
}) {
  return (
    <div className="flex items-start gap-2 flex-wrap justify-end">
      {canAdmin && (
        <button
          className={`btn btn-uniform ${showDeleted ? "" : "btn-ghost"}`}
          onClick={onToggleDeleted}
          style={showDeleted ? { background: "#18181b", borderColor: "#18181b", color: "#fff" } : {}}
          title="Ver pedidos excluídos — podem ser restaurados com senha de colaborador"
          data-testid="deleted-orders-toggle"
        >
          <ArrowCounterClockwise size={14} weight="bold" /> <span>Excluídos</span>
        </button>
      )}
      <button
        className={`btn btn-uniform ${showOverdueOnly ? "" : "btn-ghost"}`}
        onClick={onToggleOverdue}
        style={showOverdueOnly ? { background: "#E60000", borderColor: "#E60000", color: "#fff" } : { borderColor: "#E60000", color: "#E60000" }}
        title="Filtrar apenas pedidos com prazo crítico"
        data-testid="overdue-filter-toggle"
      >
        <Warning size={14} weight="bold" /> <span>Atrasados{overdueCount > 0 ? ` (${overdueCount})` : ""}</span>
      </button>
      <button
        className="btn btn-ghost btn-uniform"
        onClick={onExport}
        disabled={exporting}
        data-testid="export-excel-btn"
        title="Exporta os pedidos para Excel respeitando os filtros ativos"
      >
        <FileXls size={14} weight="bold" /> <span>{exporting ? "Exportando..." : "Exportar Excel"}</span>
      </button>
      {canAdmin && (
        <>
          <button className="btn btn-ghost btn-uniform" onClick={onRecover} data-testid="recover-overrides-btn" title="Restaurar cores/silk/imagens perdidos em syncs anteriores">
            <MagicWand size={14} weight="bold" /> <span>Recuperar Cores</span>
          </button>
          <button className="btn btn-ghost btn-uniform" onClick={onArchive} data-testid="archive-old-btn" title="Arquivar pedidos antigos">
            <Archive size={14} weight="bold" /> <span>Arquivar Antigos</span>
          </button>
          <button className="btn btn-ghost btn-uniform" onClick={onManual} data-testid="add-manual-order">
            <Plus size={14} weight="bold" /> <span>Novo Pedido</span>
          </button>
          <button className="btn btn-ghost btn-uniform" onClick={onPurge} disabled={purging} data-testid="purge-cancelled-btn" title="Remover pedidos cancelados ou excluídos no Bling">
            <Trash size={14} weight="bold" /> <span>{purging ? "Verificando..." : "Limpar Cancelados"}</span>
          </button>
          <button className="btn btn-klein btn-uniform" onClick={onSync} disabled={syncing} data-testid="sync-bling-btn">
            <ArrowsClockwise size={14} weight="bold" className={syncing ? "animate-spin" : ""} />
            <span>{syncing ? "Sincronizando..." : "Sincronizar Bling"}</span>
          </button>
        </>
      )}
    </div>
  );
}
